import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-trails-user-settings',
  templateUrl: './audit-trails-user-settings.component.html',
  styleUrls: ['./audit-trails-user-settings.component.scss']
})
export class AuditTrailsUserSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
